import React, { useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { useNavigate } from 'react-router-dom';
import { useLocalState } from './util/useLocalStorage';
import AlertaCampanita from './components/Alertas/AlertaCampanita';
import AlertaVipIndicador from './components/Alertas/AlertaVipIndicador';
import { salir } from './seguridad/sesionCliente';
import MiSeguridad from './seguridad/MiSeguridad';



const AppTopbar = (props) => {

    const navigate = useNavigate();
    /**JWT */
    const [jwt, setJwt] = useLocalState("", "jwt");
    const [username, setUsername] = useLocalState("", "username");
    const [roles, setRoles] = useLocalState("", "roles");

    const logout = async () => {
        await salir(); // cierra la sesion tambien en el servidor
        setJwt("");
        setRoles("");
        setUsername("");

        window.location.href = "/login"
    };


    useEffect(() => {

    }, [props.searchActive]);



    return (
        <div className="layout-topbar shadow-4">
            <div className="layout-topbar-left">
                <button type="button" style={{ cursor: 'pointer' }} className="layout-topbar-logo p-link" onClick={() => navigate('/')}>
                    <img id="app-logo" src="assets/layout/images/Logo_Cema.png" alt="CEMA" style={{ height: '2.25rem' }} />
                </button>
                <button type="button" className="layout-menu-button shadow-6 p-link" onClick={props.onMenuButtonClick}>
                    <i className="pi pi-chevron-right"></i>
                </button>
                <button type="button" className="layout-topbar-mobile-button p-link">
                    <i className="pi pi-ellipsis-v fs-large" onClick={props.onMobileTopbarButtonClick}></i>
                </button>
            </div>

            <div className={classNames('layout-topbar-right', { 'layout-topbar-mobile-active': props.mobileTopbarActive })}>
                <div className="layout-topbar-actions-left">

                </div>
                <div className="layout-topbar-actions-right">
                    <ul className="layout-topbar-items">
                        <li className="layout-topbar-item layout-search-item">
                            <AlertaVipIndicador />
                            <AlertaCampanita />
                            <MiSeguridad />
                            <button className="mr-4 layout-topbar-action rounded-circle p-link" onClick={logout} title="Salir" aria-label="Salir">
                                <i className="pi pi-power-off fs-large"></i>
                            </button>

                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AppTopbar;
